document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.card__swatch');
  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  card.querySelectorAll('.card__swatch').forEach(function (button) {
    button.classList.remove('is-active');
  });
  swatch.classList.add('is-active');

  const imageUrl = swatch.dataset.swatchImage;
  if (!imageUrl) return;

  const media = card.querySelector('.card__media .media');
  if (!media) return;

  const images = media.querySelectorAll('img');
  if (!images.length) return;

  images[0].removeAttribute('srcset');
  images[0].src = imageUrl;
  if (images[1]) images[1].style.display = 'none';
});
